
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Row, Alert ,Spinner} from 'reactstrap';
import { confirmSignUp, resendSignUpCode } from '@aws-amplify/auth'; // Import resendSignUp
import AuthSlider from '../AuthenticationInner/authCarousel';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ConfirmSignUp = () => {
    document.title = "Media Pulse | Confirm Sign Up";

    // Get the email from location state (from registration process)
    const location = useLocation();
    const { state } = location;
    const email = state?.email;
    ;
    
    const [loading, setLoading] = useState(false);
    const [confirmationCode, setConfirmationCode] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const navigate = useNavigate();
    const handleCodeChange = (index, value) => {
        let newCode = confirmationCode.split('');
        newCode[index - 1] = value;
        setConfirmationCode(newCode.join(''));
    };

    const getInputElement = (index) => document.getElementById('digit' + index + '-input');

    const moveToNext = (index) => {
        if (getInputElement(index).value.length === 1) {
            if (index !== 6) {
                getInputElement(index + 1).focus();
            } else {
                getInputElement(index).blur();
            }
        }
    };

    const handleSignUpConfirmation = async () => {
        setLoading(true);
        try {
            const result = await confirmSignUp({ username: email, confirmationCode });

            if (result) {
                toast.success('Sign up confirmed successfully!');
                setTimeout(() => {
                    // Navigate to dashboard or perform auto-login here
                    navigate('/dashboard');
                }, 2000);
            }
        } catch (error) {
            toast.error(error.message || 'Error confirming sign up. Please try again.');
        }
        setLoading(false);
    };

    const handleResendCode = async () => {
        try {
            // console.log({username:email});
            
            await resendSignUpCode({username:email}); // Resend confirmation code
            toast.success('A new confirmation code has been sent to your email.');
        } catch (error) {
            // console.log(error);
            
            toast.error('Failed to resend confirmation code.');
        }
    };

    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="justify-content-center g-0">
                                        <AuthSlider />
                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div className="mb-4">
                                                    <div className="avatar-lg mx-auto">
                                                        <div className="avatar-title bg-light text-primary display-5 rounded-circle">
                                                            <i className="ri-mail-line"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-muted text-center mx-lg-3">
                                                    <h4 className="">Verify Your Email</h4>
                                                    <p>Please enter the 6-digit code sent to <span className="fw-semibold">{email}</span></p>
                                                </div>

                                               
                                                <div className="mt-4">
                                                    <form>
                                                        <Row>
                                                            {[1, 2, 3, 4, 5, 6].map((index) => (
                                                                <Col className="col-2" key={index}>
                                                                    <div className="mb-3">
                                                                        <label htmlFor={`digit${index}-input`} className="visually-hidden">
                                                                            Digit {index}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-lg bg-light border-light text-center"
                                                                            maxLength="1"
                                                                            id={`digit${index}-input`}
                                                                            style={{
                                                                                fontSize: '32px',
                                                                                height: '60px',
                                                                                padding: '10px',
                                                                            }}
                                                                            onKeyUp={(e) => {
                                                                                moveToNext(index);
                                                                                handleCodeChange(index, e.target.value);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>

                                                        <div className="mt-3">
                                                            <Button color="success" disabled={loading} className="w-100" onClick={handleSignUpConfirmation}>
                                                            {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> :"Confirm"}
                                                            </Button>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p className="mb-0">
                                                        Didn't receive a code?{' '}
                                                        <span
                                                            onClick={handleResendCode}
                                                            className="fw-semibold text-primary text-decoration-underline"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Resend
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">
                                        &copy; {new Date().getFullYear()} Whistlemind Technologies LLP. Crafted with{' '}
                                        <i className="mdi mdi-heart text-danger"></i>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>

            {/* Toast Container for displaying notifications */}
           
        </React.Fragment>
    );
};

export default ConfirmSignUp;
